export const DATASOURCE_CONSTANT = "DATASOURCE";
export const APPSMITH_IP_ADDRESS = ""; //18.223.74.85

export const PRIMARY_KEY = "primary key";
export const FOREIGN_KEY = "foreign key";
